import { render } from "./breadcrumbcontent.vue?vue&type=template&id=15ce8096"
import script from "./breadcrumbcontent.vue?vue&type=script&lang=js"
export * from "./breadcrumbcontent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__